<template>
  <div class="wrapper w-full md:text-base text-xs">
    <div class="header">
      <button
        class="btnClose"
        :style="{ margin: `10px` }"
        @click="closeModal?.()"
        v-html="SVG.CLOSE"
      ></button>
    </div>
    <div :class="customClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import { SVG } from "../../utils/const";
export default defineComponent({
  name: "ModalPodcastLayout",
  props: {
    closeModal: {
      type: Function,
    },
    customClass: {
      type: String,
      default() {
        return "body";
      },
    },
  },
  data() {
    return {
      SVG,
    };
  },
});
</script>

<style>
.wrapper {
  position: absolute;
  z-index: 1000;
  top: 0;
  right: 0;
  height: 100%;
  background: var(--secondary-color);
  padding: 0px;
  box-shadow: 0px 4px 28px rgb(174 174 174 / 22%);
  opacity: 0.95;
}
.wrapper .body {
  height: 100%;
}
/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: rgb(116, 116, 116) rgb(199, 199, 199);
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 8px;
}

*::-webkit-scrollbar-track {
  background: rgb(199, 199, 199);
}

*::-webkit-scrollbar-thumb {
  background-color: rgb(116, 116, 116);
  border-radius: 3px;
}

.wrapper .header {
  position: absolute;
  right: 0;
}

.wrapper .header .btnClose {
  margin-left: auto;
}

.btnClose {
     height: auto;
    width: auto;
    border: unset;
    background-color: var(--quaternary-color) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: auto !important;
    border-radius: 50%;
    padding: 0.25em;
}

.btnClose svg {
  height: 14px;
  width: 14px;
}

@media screen and (max-height: 275px) {
  .wrapper .header .btnClose svg {
    width: 0.75em;
    height: 0.75em;
  }
}
</style>
